<template>
    <div>
      <div class="action-btn pointer">
        <button class="notify-btn" @click="showPopover($event)" >Notify Me</button>
      </div>
      <div class="inlineblock" v-if="isOptions === true">
        <div class="mobileOverlayLayer" v-if="showPopup">
          <div class="user-popover" v-if="showPopup" transition="fade" :style="'left:-' + (position * 40 + 12) + 'px'">
            <button class="closebx close" type='button' aria-label="Close" @click="hoverOutInfo($event)">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="productSize">
            <p><b>Please Enter Your Email</b></p>
          </div>
            <div class="bottomSection">
              <h3>Get notified once the product is lunched.</h3>
              <form method="POST" v-on:submit.prevent="notifyproduct">
                <div class="row">
                  <div class="col-12 pro">
                    <input type="text" name="notify.email" v-model="email" class="form-control" placeholder="Enter your email ID" @click="stopPropgation($event)">
                    <div class="message" v-if="nullError">{{ nullError }}</div>
                  </div>
                </div>
                <div class="col-8 mt-2 btn-submit">
                    <button :disabled="notifyBtnDisabled" class="btn btn-primary btn-block" @click.stop>Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import {mapGetters} from 'vuex'
    export default {
      props: ['szid', 'parentid', 'proType', 'isOptions', 'position', 'sizes', 'isSouledOut', 'isMoveToCartPopup', 'product'],
      data: function () {
        return {
          showPopup: false,
          timer: '',
          isInInfo: false,
          email: '',
          notify: {
            prod_id: this.parentid,
            sub_prod_id: this.selectedSize,
            prod_type: this.proType,
            email: ''
          },
          nullError: '',
          selectedSize: '',
          notifyBtnDisabled: false
        }
      },
      computed: {
        ...mapGetters({user: 'user', authStatus: 'authStatus'})
      },
      mounted: function () {
        this.email = this.authStatus ? this.user.email : ''
      },
      watch: {
        authStatus () {
          this.email = this.authStatus ? this.user.email : ''
        }
      },
      methods: {
        changeSize: function (selectedVariant) {
          this.selectedSize = selectedVariant
        },
        notifyproduct: function (event) {
          event.stopPropagation()
          event.preventDefault()
          let email = this.email
          let verify = false
          let emailVal = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
          this.nullError = ''
          let notifyForm = new FormData()
          notifyForm.append('email', email)
          notifyForm.append('prod_id', this.notify.prod_id)
          notifyForm.append('notification_type', this.proType)
          if (!email && !this.selectedSize && this.isOptions === true) {
            this.nullError = 'Please enter email and size.'
            verify = true
          } else if (!verify && emailVal.test(email)) {
            this.nullError = ''
            this.notifyBtnDisabled = true
            this.$store.dispatch('SET_PRODUCT_LAUNCH_NOTIFICATION', notifyForm).then((response) => {
              if (response.data.status) {
                this.email = this.authStatus ? this.user.email : this.email
                this.closePopover()
                this.notifyBtnDisabled = false
                this.$store.commit('MOENGAGE_EVENT', {eventName: 'PLP_NOTIFY_ME_SUBMIT_WEB',
                  payload: {
                    PRODUCT_NAME: this.product.product,
                    PRODUCT_CATEGORY: this.product.category,
                    ARTIST_NAME: this.product.artist.name,
                    PARENT_SKU: this.product.id,
                    PRODUCT_TAG: this.product.product_slug || 'NA'
                  }}
                )
              }
            })
          } else {
            this.nullError = 'Please enter valid email address.'
            verify = false
            this.notifyBtnDisabled = false
          }
          setTimeout(() => { this.nullError = false }, 5000)
        },
        handleClickOutside (event) {
          const popover = this.$el.querySelector('.user-popover')
          if (popover && !popover.contains(event.target)) {
            this.showPopup = false
            document.removeEventListener('click', this.handleClickOutside)
          }
        },
        hover: function () {
          let vm = this
          this.timer = setTimeout(function () {
            vm.showPopover()
          }, 100)
        },
        hoverOut: function () {
          let vm = this
          clearTimeout(vm.timer)
          this.timer = setTimeout(function () {
            if (!vm.isInInfo) {
              vm.closePopover()
            }
          }, 100)
        },
        hoverInfo: function () {
          this.isInInfo = true
        },
        hoverOutInfo: function (event) {
          event.stopPropagation()
          event.preventDefault()
          this.isInInfo = false
          this.hoverOut()
        },
        stopPropgation (event) {
          event.stopPropagation()
          event.preventDefault()
        },
        showPopover: function (event) {
          document.addEventListener('click', this.handleClickOutside)
          event.stopPropagation()
          event.preventDefault()
          this.showPopup = true
        },
        closePopover: function () {
          this.showPopup = false
        }
      }
    }
  </script>
  <style scoped="">
    .action-btn{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        position: relative;
        z-index: 10;
    }
   .notify-btn {
        width: 65%;
        height: 30px;
        padding: 0 24px;
        border-radius: 5px;
        border: 1px solid #228381;
        color: #228381;
        background-color: #fff;
   }
   .btn-submit {
    margin-left: 15%;
   }
   .btn-block {
      border-radius: 10px;
   }
    .closebx {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #a8a6a6;
      width: 25px;
      height: 25px;
      text-align: center;
      cursor: pointer;
    }
    .closebx:active,
    .closebx:hover{
      border: 0;
      outline: none;
    }
  
    .select-size{
      margin-top: 18px;
    }
    .select-size .selectcolor{
      text-decoration: underline
    }
  
    .user-popover {
      position: absolute;
      width: 100%;
      top: 80px;
      left: 0;
      background: #fff;
      border: 1px solid #ccc;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
      z-index: 99;
    }
  
    .user-popover .productSize{
      padding: 15px 15px 0px;
      background-color: #fafafa;
    }
  
    .user-popover .productSize p{
      font-size: 16px;
      margin-bottom: 10px;
    }
  
    .bottomSection{
      width: 100%;
      padding: 15px;
      display: inline-block;
    }
  
    .user-popover h3 {
      font-size: 15px;
    }
  
    .disableclick {
      display: block;
      position: absolute;
      width: 100%;
      left: 0;
      height: 100%;
      z-index: 99;
      font-size: 28px;
      color: #999696;
      font-family: 'Source Sans Pro', sans-serif;
  font-weight: 300;;
    }
    .bottomSection .col-8{
      padding-right: 0;
    }
  
    .form-control{
      border-radius: 0;
    }
    .message{
      margin-top: 5px;
      color: rgb(255, 0, 0);
      font-size: 14px;
    }
  
    @media screen and (max-width: 991px) {
      .closebx {
        display: block;
      }
    }
  
    input,
    input::-webkit-input-placeholder {
      font-size: 15px;
    }
  
    @media screen and (max-width: 768px) {
      .user-popover {
        width: 335px;
      }
      .user-popover h3 {
        padding: 5px 2px;
        font-size: 14px;
      }
      .mobileOverlayLayer{
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: rgba(0, 0, 0, 0.45);
        transition: width 2s, height 2s, background-color 2s;
        left: 0;
        top: 0;
        z-index: 99999;
      }
      .user-popover{
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .bx1 p, .bx1 {
        margin-bottom: 2px !important;
      }
    }
  </style>



// WEBPACK FOOTER //
// notifyMe.vue?777aaa1c